var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRomania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04856 18.0024C14.0206 18.0024 18.0512 13.9718 18.0512 8.99973C18.0512 4.0277 14.0206 -0.00292969 9.04856 -0.00292969C4.07653 -0.00292969 0.0458984 4.0277 0.0458984 8.99973C0.0458984 13.9718 4.07653 18.0024 9.04856 18.0024Z",
    fill: "#CE1126"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04795 -0.00289822C7.73478 -0.00636991 6.43676 0.277476 5.2449 0.828733C4.05304 1.37999 2.99621 2.18531 2.14852 3.18822C1.30083 4.19113 0.682798 5.36734 0.337777 6.63438C-0.00724388 7.90141 -0.0709047 9.22858 0.151259 10.5228C0.373423 11.8171 0.876033 13.047 1.62384 14.1265C2.37165 15.2059 3.34655 16.1087 4.48017 16.7715C5.61379 17.4343 6.87869 17.8411 8.18616 17.9633C9.49362 18.0855 10.812 17.9203 12.0488 17.4791V0.520456C11.0858 0.175966 10.0708 -0.00104444 9.04795 -0.00289822Z",
    fill: "#FCD116"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0458984 8.99981C0.0469506 7.1394 0.624656 5.32504 1.69949 3.80652C2.77431 2.288 4.29342 1.13999 6.04767 0.520508V17.4791C4.29342 16.8596 2.77431 15.7116 1.69949 14.1931C0.624656 12.6746 0.0469506 10.8602 0.0458984 8.99981Z",
    fill: "#002B7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomania);
export default __webpack_public_path__ + "static/media/Romania.9d20c148f8ce2bfd5f02c77bb3636577.svg";
export { ForwardRef as ReactComponent };